module.exports = __webpack_public_path__ + "static/media/Tiras de pollo a la parrilla.dc67da56.png";